import React from 'react'
import { dark, shadow } from '../tokens'

const navButtonStyle = (side: 'left' | 'right', disabled: boolean): React.CSSProperties => ({
  position: 'fixed',
  top: '50%',
  [side]: 24,
  transform: 'translateY(-50%)',
  zIndex: 1400,
  width: 48,
  height: 48,
  borderRadius: '50%',
  border: `1px solid ${dark.hairline}`,
  background: dark.surface,
  color: dark.text,
  fontSize: 22,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.4 : 1,
  boxShadow: shadow.overlay,
})

/**
 * Prev/next for the review walkthrough, shared by the ad modal and the theme
 * slide so both steps are navigated the same way. Fixed to the screen edges
 * rather than the dialog: the dialog is as tall as the viewport allows, and
 * arrows inside it would eat width the ad and its copy are already competing
 * for.
 */
export function ReviewNavRail({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
}: {
  hasPrev: boolean
  hasNext: boolean
  onPrev: () => void
  onNext: () => void
}) {
  return (
    <>
      <button
        type="button"
        aria-label="Previous"
        disabled={!hasPrev}
        onClick={onPrev}
        style={navButtonStyle('left', !hasPrev)}
      >
        ‹
      </button>
      <button
        type="button"
        aria-label="Next"
        disabled={!hasNext}
        onClick={onNext}
        style={navButtonStyle('right', !hasNext)}
      >
        ›
      </button>
    </>
  )
}
